import React, { useEffect, useState } from "react";
import CardDetailsModal from "@/components/CardDetailsModal";

export default function GlobalCardDetailsHost() {
  const [open, setOpen] = useState(false);
  const [payload, setPayload] = useState<{ card: any; owner: any } | null>(null);

  // GlobalCardDetailsHost.tsx
useEffect(() => {
  // @ts-ignore
  (window as any).__sg_openCardDetailsItem = (item: any) => {
    setPayload(item);
    setOpen(true);
  };
  return () => { /* cleanup */ };
}, []);

return payload ? (
  <CardDetailsModal
    open={open}
    onClose={() => setOpen(false)}
    item={payload}
    onMakeOffer={() => {
      // Optional: if you want offers from the global host, open your shared offer modal here.
      // Or leave it to the page-based flow.
    }}
    sellerRender={() => {
      const uname = String(payload?.username || payload?.ownerUid || "").trim();
      const handle = uname.startsWith("@") ? uname : (uname ? `@${uname}` : "");
      const profileHref = uname ? `/${encodeURIComponent(uname.replace(/^@/, ""))}` : "#";
      return (
        <div className="flex items-center justify-between gap-3 rounded-lg border border-white/10 bg-black/40 px-3 py-2">
          <div className="min-w-0 flex items-center gap-2">
            <img
              src={payload?.ownerAvatar || "/images/avatar-default.png"}
              alt={uname || "seller"}
              className="h-8 w-8 rounded-full object-cover ring-1 ring-white/15"
            />
            <div className="min-w-0">
              <div className="truncate text-sm font-medium text-white">{handle || "seller"}</div>
              {typeof payload?.distance === "number" && Number.isFinite(payload.distance) ? (
                <div className="truncate text-xs text-white/60">{Math.round(payload.distance)} miles away</div>
              ) : null}
            </div>
          </div>
          {uname ? (
            <Link
              to={profileHref}
              className="rounded-md border border-white/15 px-2 py-1 text-xs text-white/80 hover:bg-white/10"
            >
              View Profile
            </Link>
          ) : null}
        </div>
      );
    }}
  />
) : null;


}

